define.alias("shared/components/shared/base-time-picker", "media/components/shared/base-time-picker");